import { useCallback, useMemo } from "react"

import { RadioGroup, Radio, FormControlLabel, useTheme } from "@mui/material"

import { useTranslation } from "providers/i18n"
import { useVenue } from "providers/venue"
import { getFeatureDetail } from "utils/feature"
import { Image } from "components/Image"
import { DEFAULT_VENUE_FILTER } from "../../../../constant"

export const FilterVenueRadioButtons = (props) => {
  const { value = DEFAULT_VENUE_FILTER, onChange } = props
  const { t } = useTranslation()
  const { venues = [], isMultiVenueProject } = useVenue()
  const venueInfos = useMemo(() => {
    return venues.map(getFeatureDetail)
  }, [venues])

  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiFilterVenueRadioButtons`]?.styleOverrides || {}
  const { root, labelImage, formControlLabel } = styleOverrides

  const handleCheck = useCallback(
    (event) => {
      onChange(event.target.value)
    },
    [onChange]
  )

  return (
    isMultiVenueProject && (
      <RadioGroup row value={value} onChange={handleCheck} sx={root}>
        {venueInfos.map(({ id, name, logo, reference }) => {
          return (
            <FormControlLabel
              key={`venue-filter-${id}`}
              className={reference}
              sx={formControlLabel}
              label={logo ? <Image src={logo} sx={labelImage} /> : t(name)}
              control={<Radio color="primary" />}
              value={id}
            />
          )
        })}
        <FormControlLabel
          control={<Radio color="primary" />}
          label={t("All Mall")}
          className={"all"}
          sx={formControlLabel}
          value={DEFAULT_VENUE_FILTER}
        />
      </RadioGroup>
    )
  )
}
